// import React, { useEffect, useState } from "react";
// import "./styles.scss";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//     faChevronLeft,
//     faChevronRight
// } from "@fortawesome/free-solid-svg-icons";
// import { useMenuHubApi } from "../../api/menuHub";
// import { useNavigate, useParams, useLocation } from "react-router-dom";

// const AddUserPage: React.FC = () => {
//     const { email: emailParam } = useParams<{ email?: string }>();
//     const location = useLocation();
//     const navigate = useNavigate();

//     const query = new URLSearchParams(location.search);
//     const loginTasyParam = query.get("loginTasy") || "";

//     const { createProfile, getUserProfiles, getAllProfiles, updateUser } = useMenuHubApi();

//     const [email, setEmail] = useState(emailParam || "");
//     const [tasyUser, setTasyUser] = useState(loginTasyParam);
//     const [loading, setLoading] = useState(false);

//     const [emailError, setEmailError] = useState("");

//     const [showErrorModal, setShowErrorModal] = useState(false);
//     const [errorMessage, setErrorMessage] = useState("");

//     const [available, setAvailable] = useState<string[]>([]);
//     const [selected, setSelected] = useState<string[]>([]);
//     const [searchLeft, setSearchLeft] = useState("");
//     const [searchRight, setSearchRight] = useState("");

//     const [selectedAvailableItems, setSelectedAvailableItems] = useState<string[]>([]);
//     const [selectedSelectedItems, setSelectedSelectedItems] = useState<string[]>([]);

//     const filteredAvailable = available.filter(p =>
//         p.toLowerCase().includes(searchLeft.toLowerCase())
//     );

//     const filteredSelected = selected.filter(p =>
//         p.toLowerCase().includes(searchRight.toLowerCase())
//     );

//     const toggleAvailableItem = (item: string) => {
//         setSelectedAvailableItems(prev =>
//             prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item]
//         );
//     };

//     const toggleSelectedItem = (item: string) => {
//         setSelectedSelectedItems(prev =>
//             prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item]
//         );
//     };

//     const moveRight = () => {
//         setAvailable(prev => prev.filter(i => !selectedAvailableItems.includes(i)));
//         setSelected(prev => [...prev, ...selectedAvailableItems]);
//         setSelectedAvailableItems([]);
//     };

//     const moveLeft = () => {
//         setSelected(prev => prev.filter(i => !selectedSelectedItems.includes(i)));
//         setAvailable(prev => [...prev, ...selectedSelectedItems]);
//         setSelectedSelectedItems([]);
//     };

//     const moveAllRight = () => {
//         setSelected(prev => [...prev, ...available]);
//         setAvailable([]);
//     };

//     const moveAllLeft = () => {
//         setAvailable(prev => [...prev, ...selected]);
//         setSelected([]);
//     };

//     useEffect(() => {
//         const load = async () => {
//             try {
//                 const allProfiles = await getAllProfiles();
//                 setAvailable(allProfiles);
//             } catch {
//                 setAvailable([]);
//             }
//         };
//         load();
//     }, []);

//     const handleSave = async () => {
//         if (!email) {
//             setEmailError("E-mail é obrigatório");
//             return;
//         }

//         setEmailError("");
//         setLoading(true);

//         try {
//             if (emailParam) {
//                 await updateUser({
//                     email,
//                     loginTasy: tasyUser,
//                     solucoesPermitidas: selected.join(","),
//                 });
//             } else {
//                 await createProfile({
//                     email,
//                     loginTasy: tasyUser,
//                     solucoesPermitidas: selected.join(","),
//                 });
//             }

//             navigate("/admin-panel");
//         } catch (err: any) {
//             setErrorMessage(
//                 err?.response?.data?.detalhe ||
//                 err?.response?.data?.mensagem ||
//                 "Erro ao salvar usuário"
//             );
//             setShowErrorModal(true);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="page-container">

//             <div className="content-row">
//                 <div className="form-section form-container"> 
//                     <h3>{emailParam ? "Editar usuário" : "Adicionar usuário"}</h3>

//                     <label>E-mail</label>
//                     <input
//                         type="email"
//                         value={email}
//                         disabled={!!emailParam}
//                         style={{ backgroundColor: emailParam ? "#f1eaea" : "#fff" }}
//                         onChange={(e) => setEmail(e.target.value)}
//                     />
//                     {emailError && <span className="field-error">{emailError}</span>}

//                     <label>Usuário Tasy</label>
//                     <input
//                         type="text"
//                         value={tasyUser}
//                         onChange={(e) => setTasyUser(e.target.value)}
//                     />
//                 </div>

//                 <div className="access-section">
//                     <strong>Atribuir permissões</strong>

//                     <div className="transfer-container">
//                         <div className="transfer-box">
//                             <div className="transfer-header">
//                                 Disponíveis <span>{available.length}</span>
//                             </div>
//                             <input
//                                 className="transfer-search"
//                                 placeholder="Procurar"
//                                 value={searchLeft}
//                                 onChange={(e) => setSearchLeft(e.target.value)}
//                             />
//                             <div className="transfer-list">
//                                 {filteredAvailable.map(item => (
//                                     <div
//                                         key={item}
//                                         className={`transfer-item ${selectedAvailableItems.includes(item) ? "selected" : ""}`}
//                                         onClick={() => toggleAvailableItem(item)}
//                                     >
//                                         {item}
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>

//                         <div className="transfer-buttons">
//                             <button onClick={moveAllRight}>≫</button>
//                             <button onClick={moveRight} disabled={!selectedAvailableItems.length}>
//                                 <FontAwesomeIcon icon={faChevronRight} />
//                             </button>
//                             <button onClick={moveLeft} disabled={!selectedSelectedItems.length}>
//                                 <FontAwesomeIcon icon={faChevronLeft} />
//                             </button>
//                             <button onClick={moveAllLeft}>≪</button>
//                         </div>

//                         <div className="transfer-box">
//                             <div className="transfer-header">
//                                 Selecionados <span>{selected.length}</span>
//                             </div>
//                             <input
//                                 className="transfer-search"
//                                 placeholder="Procurar"
//                                 value={searchRight}
//                                 onChange={(e) => setSearchRight(e.target.value)}
//                             />
//                             <div className="transfer-list">
//                                 {filteredSelected.map(item => (
//                                     <div
//                                         key={item}
//                                         className={`transfer-item ${selectedSelectedItems.includes(item) ? "selected" : ""}`}
//                                         onClick={() => toggleSelectedItem(item)}
//                                     >
//                                         {item}
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="buttons">
//                 <button className="cancel" onClick={() => navigate("/admin-panel")}>
//                     Cancelar
//                 </button>
//                 <button className="add" onClick={handleSave} disabled={loading}>
//                     {loading ? "Salvando..." : "Salvar"}
//                 </button>
//             </div>

//             {showErrorModal && (
//                 <div className="modal-overlay">
//                     <div className="modal">
//                         <h3>Erro</h3>
//                         <p>{errorMessage}</p>
//                         <button className="btn-confirm" onClick={() => setShowErrorModal(false)}>
//                             OK
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };
// export default AddUserPage;

import React, { useEffect, useState } from "react";
import "./styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronLeft,
    faChevronRight
} from "@fortawesome/free-solid-svg-icons";
import { useMenuHubApi } from "../../api/menuHub";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import dArrowRight from "../../assets/icons/fontawesome/svgs/solid/chevrons-right.svg"
import dArrowLeft from "../../assets/icons/fontawesome/svgs/solid/chevrons-left.svg"

const AddUserPage: React.FC = () => {
    const { email: emailParam } = useParams<{ email?: string }>();
    const location = useLocation();
    const navigate = useNavigate();

    const query = new URLSearchParams(location.search);
    const loginTasyParam = query.get("loginTasy") || "";

    const { createProfile, getUserProfiles, getAllProfiles, updateUser } = useMenuHubApi();

    const [email, setEmail] = useState(emailParam || "");
    const [tasyUser, setTasyUser] = useState(loginTasyParam);
    const [loading, setLoading] = useState(false);

    const [emailError, setEmailError] = useState("");
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [available, setAvailable] = useState<string[]>([]);
    const [selected, setSelected] = useState<string[]>([]);
    const [searchLeft, setSearchLeft] = useState("");
    const [searchRight, setSearchRight] = useState("");

    const [selectedAvailableItems, setSelectedAvailableItems] = useState<string[]>([]);
    const [selectedSelectedItems, setSelectedSelectedItems] = useState<string[]>([]);

    const filteredAvailable = available.filter(p =>
        p.toLowerCase().includes(searchLeft.toLowerCase())
    );

    const filteredSelected = selected.filter(p =>
        p.toLowerCase().includes(searchRight.toLowerCase())
    );

    const toggleAvailableItem = (item: string) => {
        setSelectedAvailableItems(prev =>
            prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item]
        );
    };

    const toggleSelectedItem = (item: string) => {
        setSelectedSelectedItems(prev =>
            prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item]
        );
    };

    const moveRight = () => {
        if (!selectedAvailableItems.length) return;

        setAvailable(prev => prev.filter(i => !selectedAvailableItems.includes(i)));
        setSelected(prev => [...prev, ...selectedAvailableItems]);
        setSelectedAvailableItems([]);
    };

    const moveLeft = () => {
        if (!selectedSelectedItems.length) return;

        setSelected(prev => prev.filter(i => !selectedSelectedItems.includes(i)));
        setAvailable(prev => [...prev, ...selectedSelectedItems]);
        setSelectedSelectedItems([]);
    };

    const moveAllRight = () => {
        if (!available.length) return;

        setSelected(prev => [...prev, ...available]);
        setAvailable([]);
        setSelectedAvailableItems([]);
    };

    const moveAllLeft = () => {
        if (!selected.length) return;

        setAvailable(prev => [...prev, ...selected]);
        setSelected([]);
        setSelectedSelectedItems([]);
    };

    // 🔥 LOAD CORRETO (CREATE + EDIT)
    useEffect(() => {
        const loadData = async () => {
            try {
                const allProfiles = await getAllProfiles();

                if (emailParam) {
                    const userData = await getUserProfiles(emailParam);
                    const userProfiles = userData?.perfis || [];

                    setSelected(userProfiles);
                    setAvailable(allProfiles.filter((p: any) => !userProfiles.includes(p)));
                } else {
                    setAvailable(allProfiles);
                    setSelected([]);
                }
            } catch {
                setAvailable([]);
                setSelected([]);
            }
        };

        loadData();
    }, [emailParam]);

    const handleSave = async () => {
        if (!email) {
            setEmailError("E-mail é obrigatório");
            return;
        }

        setEmailError("");
        setLoading(true);

        try {
            if (emailParam) {
                await updateUser({
                    email,
                    loginTasy: tasyUser,
                    solucoesPermitidas: selected.join(","),
                });
            } else {
                await createProfile({
                    email,
                    loginTasy: tasyUser,
                    solucoesPermitidas: selected.join(","),
                });
            }

            navigate("/painel-central/admin-panel");
        } catch (err: any) {
            setErrorMessage(
                err?.response?.data?.detalhe ||
                err?.response?.data?.mensagem ||
                "Erro ao salvar usuário"
            );
            setShowErrorModal(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container">
            <div className="content-row">
                <div className="form-section form-container">
                    <h3>{emailParam ? "Editar usuário" : "Adicionar usuário"}</h3>

                    <label>E-mail</label>
                    <input
                        type="email"
                        value={email}
                        disabled={!!emailParam}
                        style={{ backgroundColor: emailParam ? "#f1eaea" : "#fff" }}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    {emailError && <span className="field-error">{emailError}</span>}

                    <label>Usuário Tasy</label>
                    <input
                        type="text"
                        value={tasyUser}
                        onChange={(e) => setTasyUser(e.target.value)}
                    />
                </div>

                <div className="access-section">
                    <strong>Atribuir permissões</strong>

                    <div className="transfer-container">
                        <div className="transfer-box">
                            <div className="transfer-header">
                                Disponíveis <span>{available.length}</span>
                            </div>

                            <input
                                className="transfer-search"
                                placeholder="Procurar"
                                value={searchLeft}
                                onChange={(e) => setSearchLeft(e.target.value)}
                            />

                            <div className="transfer-list">
                                {filteredAvailable.map(item => (
                                    <div
                                        key={item}
                                        className={`transfer-item ${selectedAvailableItems.includes(item) ? "selected" : ""}`}
                                        onClick={() => toggleAvailableItem(item)}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* <div className="transfer-buttons">
                            {selectedAvailableItems.length > 0 && <button onClick={moveAllRight}>
                                <img width={24} height={24} src={dArrowRight}></img></button>
                            }
                            {selectedAvailableItems.length > 0 && <button onClick={moveRight} >
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>}
                            {selectedSelectedItems.length > 0 && <button onClick={moveLeft}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>}
                            {selectedSelectedItems.length && <button onClick={moveAllLeft} disabled={!selected.length}>
                                <img width={24} height={24} src={dArrowLeft}></img>
                            </button>}
                        </div> */}

                        <div className="transfer-buttons">

                            {/* BOTÕES → DIREITA */}
                            {available.length > 0 && (
                                <>
                                    <button onClick={moveAllRight}>
                                        <img width={12} height={12} src={dArrowRight} />
                                    </button>

                                    <button onClick={moveRight}>
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </button>
                                </>
                            )}

                            {/* BOTÕES → ESQUERDA */}
                            {selected.length > 0 && (
                                <>
                                    <button onClick={moveLeft}>
                                        <FontAwesomeIcon icon={faChevronLeft} />
                                    </button>

                                    <button onClick={moveAllLeft}>
                                        <img width={12} height={12} src={dArrowLeft} />
                                    </button>
                                </>
                            )}

                        </div>


                        <div className="transfer-box">
                            <div className="transfer-header">
                                Selecionados <span>{selected.length}</span>
                            </div>

                            <input
                                className="transfer-search"
                                placeholder="Procurar"
                                value={searchRight}
                                onChange={(e) => setSearchRight(e.target.value)}
                            />

                            <div className="transfer-list">
                                {filteredSelected.map(item => (
                                    <div
                                        key={item}
                                        className={`transfer-item ${selectedSelectedItems.includes(item) ? "selected" : ""}`}
                                        onClick={() => toggleSelectedItem(item)}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="buttons">
                <button className="cancel" onClick={() => navigate("/painel-central/admin-panel")}>
                    Cancelar
                </button>
                <button className="add" onClick={handleSave} disabled={loading}>
                    {loading ? "Salvando..." : "Salvar"}
                </button>
            </div>

            {showErrorModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h3>Erro ao salvar o registro!</h3>
                        <p>{errorMessage}</p>
                        <button className="btn-confirm" onClick={() => setShowErrorModal(false)}>
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddUserPage;
